import { Module, Mutation, VuexModule, config } from "vuex-module-decorators";
import { IKycRecord } from "../types";

config.rawError = true;

@Module({ namespaced: true })
export default class KycModule extends VuexModule {
  kyc: IKycRecord | null = null;

  @Mutation
  setKyc(kyc: IKycRecord | null) {
    this.kyc = kyc;
  }

  @Mutation
  clear() {
    this.kyc = null;
  }
}
